import { supabase } from '../lib/supabase';

/**
 * Limpa todos os dados de sessão, armazenamento local e cookies.
 */
export const clearAllData = async (): Promise<void> => {
  try {
    // 1. Encerra a sessão do Supabase
    const { error: signOutError } = await supabase.auth.signOut();
    if (signOutError) {
      console.error('Erro ao encerrar a sessão do Supabase:', signOutError);
      // Mesmo com erro, continua a limpeza
    }

    // 2. Limpa o localStorage
    localStorage.clear();

    // 3. Remove cookies relacionados à aplicação
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }

    console.log('Todos os dados de sessão foram limpos com sucesso.');

  } catch (error) {
    console.error('Falha ao limpar os dados da sessão:', error);
    // Adicionar tratamento de erro mais robusto se necessário
  }
};
